import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var HighlightContent = styled(Flex).withConfig({
  displayName: "partials__HighlightContent",
  componentId: "sc-17t1jv2-0"
})(["flex-direction:column;justify-content:space-between;width:100%;margin:0 auto;", ";"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";;\n    flex-direction: row;\n  "])), function (_ref) {
  var _ref$leftMargin = _ref.leftMargin,
    leftMargin = _ref$leftMargin === void 0 ? false : _ref$leftMargin;
  return leftMargin ? '80%' : '100%';
}));
export var Highlight = styled.div.withConfig({
  displayName: "partials__Highlight",
  componentId: "sc-17t1jv2-1"
})(["width:100%;", ";"], minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 35%;\n\n    &:last-child {\n      left: 0;\n    }\n  "]))));
export var Title = styled.h2.withConfig({
  displayName: "partials__Title",
  componentId: "sc-17t1jv2-2"
})(["", ";margin-bottom:55px;font-weight:600;&:after{display:block;position:absolute;width:60px;height:4px;border-radius:4px;margin-top:20px;content:'';background-color:", ";}"], getFont(3), function (_ref2) {
  var theme = _ref2.theme,
    _ref2$isPromotion = _ref2.isPromotion,
    isPromotion = _ref2$isPromotion === void 0 ? false : _ref2$isPromotion;
  return isPromotion ? theme.colors.chart4 : theme.colors.primary;
});
export var Subtitle = styled.h3.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-17t1jv2-3"
})(["", ";margin-bottom:8px;font-weight:500;svg{color:", ";}"], getFont(2), function (_ref3) {
  var theme = _ref3.theme,
    _ref3$isPromotion = _ref3.isPromotion,
    isPromotion = _ref3$isPromotion === void 0 ? false : _ref3$isPromotion;
  return isPromotion ? theme.colors.chart4 : theme.colors.primary;
});
export var Summary = styled.p.withConfig({
  displayName: "partials__Summary",
  componentId: "sc-17t1jv2-4"
})(["", ";margin-bottom:12px;color:", ";"], getFont('-1'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciary;
});